// @ts-nocheck
import { OrderModel, OrderStatusMappingModel } from "@insite/client-framework/Types/ApiModels";

const getOrderStatusMappingStatusColor = (
    order: OrderModel,
    orderStatusMapping: OrderStatusMappingModel[] | undefined,
) => {
    const orderStatusMappingColor = orderStatusMapping?.find(mapping => mapping.erpOrderStatus === order.status)
        ?.properties.statusColor;

    return orderStatusMappingColor ?? "";
};

export default getOrderStatusMappingStatusColor;
